import type { AppDefinition } from '../../../../types/apps';

const icd10xDefinition: AppDefinition = {
  appId: 'phys-icd10x',
  name: 'ICD-10 Extractor',
  version: '1.0.0',
  description:
    'Paste a progress-note assessment and extract ICD-10 and CPT codes into a table — AI-assisted, NLM-validated, tunable per practice.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-icd10x',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'ListMagnifyingGlass',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-icd10x',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
};

export default icd10xDefinition;
